import Vue from "vue";
import LinePreloader from "@/components/common/preloaders/LinePreload.vue";
import vueI18n from "@/i18n.ts";
import store from "@/store/index";

let isAlreadyLoad: boolean = false;

const addPreload = (el, opt = {}) => {
  const ComponentClass = Vue.extend(LinePreloader);
  const instance = new ComponentClass({ propsData: opt });
  instance.$mount();
  el.appendChild(instance.$el);
};

const innerText = (el, _text) => {
  const text = vueI18n.t(_text);
  el.innerHTML = text;
};
const removePreload = (el, _text) => {
  innerText(el, _text);
  store.subscribe(({ type }) => {
    if (type === "app/setCurrentLang") {
      innerText(el, _text);
    }
  });
};

const isFontLoad = async (): Promise<boolean> => {
  return new Promise<boolean>(res => {
    store.getters["app/isFontLoad"] ? res(true) : null;
    store.subscribe(({ type }) => {
      type === "app/setFontLoad" ? res(true) : null;
    });
  });
};

export default {
  bind: async (el, { value }) => {
    if (!isAlreadyLoad) {
      addPreload(el, "opt" in value ? value.opt : {});
      await isFontLoad();
      isAlreadyLoad = true;
    }
    removePreload(el, value.text);
  }
};
